import BlockDelete from './BlockDelete';

export default BlockDelete;
